import * as React from "react";
import { Redirect } from "react-router-dom";

const GoHome: React.FC = () => <Redirect to="/" />;

export default GoHome;
